import { MOOD_CONFIG, MOOD_LEVELS, type MoodLevel } from '../api/mockData';

interface MoodSelectorProps {
  selected?: MoodLevel;
  onSelect: (mood: MoodLevel) => void;
}

export function MoodSelector({ selected, onSelect }: MoodSelectorProps) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      gap: '12px',
      padding: '8px 0',
    }}>
      {MOOD_LEVELS.map((level, i) => {
        const config = MOOD_CONFIG[level];
        const isSelected = selected === level;

        return (
          <button
            key={level}
            onClick={() => onSelect(level)}
            className={`animate-fade-up stagger-${i + 1}`}
            aria-label={`Mood: ${config.label}`}
            aria-pressed={isSelected}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '6px',
              padding: '12px 10px',
              border: isSelected ? `2px solid ${config.deepColor}` : '2px solid transparent',
              borderRadius: '16px',
              background: isSelected ? config.bgColor : 'transparent',
              cursor: 'pointer',
              transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: isSelected ? 'scale(1.1)' : 'scale(1)',
              boxShadow: isSelected ? `0 4px 20px ${config.color}66` : 'none',
              minWidth: '56px',
            }}
            onMouseEnter={(e) => {
              if (!isSelected) {
                (e.currentTarget as HTMLButtonElement).style.background = config.bgColor;
                (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected) {
                (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
                (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
              }
            }}
          >
            <span style={{
              fontSize: '2rem',
              lineHeight: 1,
              filter: isSelected ? 'none' : 'grayscale(30%)',
              transition: 'filter 0.2s',
            }}>
              {config.emoji}
            </span>
            <span style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.7rem',
              fontWeight: isSelected ? 600 : 400,
              color: isSelected ? config.deepColor : 'var(--journal-ink-light)',
              letterSpacing: '0.02em',
              textTransform: 'uppercase',
              transition: 'color 0.2s',
            }}>
              {config.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
